// extracted by mini-css-extract-plugin
export default {"card":"yL","cardrow":"zL","cardcentered":"AL","details":"BL","imgwrapper":"CL","img":"EL","category":"FL","name":"GL","copy":"HL","detailsbtn":"IL","remove":"JL","price":"KL","netPrice":"LL","regularPrice":"ML","label":"NL"};
    if(module.hot) {
      // 1715188236792
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  